import React, { useState } from 'react';
import XLSX from 'xlsx';
import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import keywords,{keyGroupArray,keyToLabel,getLabelKey} from './keywords';
import { v4 as uuidv4 } from 'uuid';
import Language from './language';

const mappedData = ({lng,data,headers,Labels={}})=>data.map((row) => {
  
  const newRow = {id:uuidv4()};
  
  Object.keys(row).forEach((rowKey,i)=>{
      const value=row[rowKey];
      const {key,options} = Labels[i];
      
      newRow[key] =getLabelKey(lng,key,value);
      newRow[key] =value;
    });
  // for (const rowKey in row) {      
    // if (Labels.hasOwnProperty(rowKey)) {
      
      // console.log(getLabelKey(lng,key,value));
    // }     
  // }
  // console.log("newRow",newRow)
  return newRow;
});

const readSheet =({lng,workbook,sheet,Labels})=>{ 
  const worksheet = workbook.Sheets[sheet];    
  
  const data = XLSX.utils.sheet_to_json(worksheet);          
  const headers = keywords.filter(o=>o.group=="dataColHeader").reduce((acc,o)=>({...acc,[o.key]:o[lng]}),{})
  
  const values = mappedData({lng,data,headers,Labels});     
  
  return values;      
};



const readDATA=(props)=>readSheet({...props,sheet:props.lng=="en"?"DATA":"DONNÉES",Labels:[
   {"key":'ItemID'},
   {"key":'InventoryYear'},
   {"key":'Port Authority'},    
   {"key":'Terminal'},    
   {"key":'Boundary'},   
   {"key":'Activity'},    
   {"key":'SourceGroup'},    
   {"key":'SourceSubGroup'}, 
   {"key":'Equipment'}, 
   {"key":'fuel_ID'}, 
   {"key":'ppm_sulphur'}, 
  // {"key":'retro_ID'}, 
   {"key":'SubstanceGroup'}, 
   {"key":'Substance'}, 
   {"key":'SubstanceID'}, 
   {"key":'Amount'}, 
   {"key":'Units'},
   

]


});



export const excel2json=({lng,binary})=>{
  
  const workbook = XLSX.read(binary);
  const data = readDATA({lng,workbook});
  console.log("DATA",data);
  return data
}

const ExcelHandler = ({lng,onFinish}) => {
  

  

  const handleFileUpload = (info) => {    
    if (info.file.status === 'done') {


      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryString = e.target.result;        
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const data = readDATA({lng,workbook})
       
        const filteredData = data.filter(o=>o.SubstanceID!="co2e")
        onFinish&&onFinish(data);
      };

      reader.readAsBinaryString(info.file.originFileObj);
    } else if (info.file.status === 'error') {
      message.error('File upload failed.');
    }
  };  

  return (
    <div>    
      <Upload.Dragger
        name="file"
        accept=".xlsx"
        customRequest={({ onSuccess, onError, file }) => {
          setTimeout(() => {
            onSuccess({}, file);
          }, 1000);
        }}
        onChange={(info) => handleFileUpload(info)}
      >
        <p className="ant-upload-drag-icon">
          <UploadOutlined />
        </p>
        <p className="ant-upload-text"><Language id="uploadmessage"/></p>
        <p className="ant-upload-hint">                    </p>
      </Upload.Dragger>
      
     
     
    </div>
  );
};

export default ExcelHandler;